export const YearOfBirthFilterButton = ({object, yearOfActivities, yearOfBirth, active, handleClick, dictionaryWords, ...props}) => {
    return <div key={object.YearOfBirth}>
        <button
            className={
                active &&
                    yearOfBirth == object.YearOfBirth
                    ? "active"
                    : ""
            }
            id={object.YearOfBirth}
            onClick={handleClick}
        >
            {object.YearOfBirth === yearOfActivities - 18
                ? `${object.YearOfBirth} ${dictionaryWords.andEarlier}`
                : object.YearOfBirth}
            <span>{`(${object.Count})`}</span>
            <i className="fa fa-close"></i>
        </button>
    </div>;
};